import { render, staticRenderFns } from "./OwnershipConflictsExportForm.vue?vue&type=template&id=1ac7d106&"
import script from "./OwnershipConflictsExportForm.vue?vue&type=script&lang=js&"
export * from "./OwnershipConflictsExportForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports